import React, { useState, useMemo, useEffect } from "react";
import HeaderComponents from "../../components/HeaderComponents";
import "../../utils/Style/pages/Overview.scss";
import AccountsSection from "../../components/Overview/AccountsSection";
import OverviewAccountSkeleton from "../../components/skeletons/OverviewAccountSkeleton";
import OverviewSection from "../../components/Overview/OverviewSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { useTable } from "react-table";
import Table from "../../components/Table";
import { capitalizeFirstLetters, formatLBP, formatUSD } from "../../features/ValueFormater";
import BlurLoading from "../../components/BlurLoading";
import useRecentOrdersApi from "../../api/RecentOrdersApi";
import { useDispatch, useSelector } from "react-redux";
import OverviewDetailsPopup from "../../components/Overview/OverviewDetailsPopup";
import { setShowOverviewDetialsPopup } from "../../features/overviewSlice";
import TableSkeleton from "../../components/skeletons/TableSkeleton";
import PaginationOverview from "../../components/PaginationOverview";
import TableSelect from "../../components/TableSelect";
import UtcToLocal from "../../components/UtcToLocal";

function Overview({ method }) {
  const [loading, setLoading] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(-1);
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedOrderType, setSelectedOrderType] = useState("All Orders");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedSearchField, setSelectedSearchField] = useState("All");

  const dispatch = useDispatch();

  const { GetDashboardOrdersSummary, GetOverviewOrders, totalNbOfPage, overviewLoading } = useRecentOrdersApi();
  const showOverviewDetialsPopup = useSelector(state => state.overview.showOverviewDetialsPopup);
  const dashboardOrdersSummary = useSelector(state => state.overview.dashboardOrdersSummary);
  const overviewOrders = useSelector(state => state.overview.overviewOrders);
  const lastRequest = useSelector(state => state.overview.lastRequest);
  const webSocketMessage = useSelector((state) => state.websocket.webSocketMessage);
  const role = sessionStorage.getItem("Role");

  useEffect(() => {
    GetDashboardOrdersSummary();
  }, [])

  const [dateRange, setDateRange] = useState([
    new Date(new Date().setMonth(new Date().getMonth() - 1)),
    new Date(),
  ]);

  const [dateString, setDateString] = useState({
    startDateString: "",
    endDateString: ""
  });

  useEffect(() => {
    if (webSocketMessage) {
      const messageData = JSON.parse(webSocketMessage.message.data);

      if (
        messageData.Event === "NewCashPickup" ||
        messageData.Event === "NewCashWithdrawTodo" ||
        messageData.Event === "OrderAssigned" ||
        messageData.Event === "OrderOutForDelivery" ||
        messageData.Event === "OrderCompleted" ||
        messageData.Event === "OrderCancelled"
      ) {
        GetDashboardOrdersSummary();
        GetOverviewOrders();
      }
    }
  }, [webSocketMessage])

  useEffect(() => {
    const [start] = dateRange;
    const end = new Date();

    if (start && !isNaN(start) && !isNaN(end)) {
      const startDate = new Date(Date.UTC(start.getUTCFullYear() - 1, start.getUTCMonth(), start.getUTCDate()));
      const endDate = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));

      const startDateString = startDate.toISOString().substring(0, 10);
      const endDateString = endDate.toISOString().substring(0, 10);

      setDateString({
        startDateString,
        endDateString,
      });

      GetOverviewOrders(1, startDateString, endDateString, selectedOrderType, 0, "All", "");
    }
  }, [dateRange, selectedOrderType]);

  const handleSearch = () => {
    const [start] = dateRange;
    const end = new Date();

    if (start && !isNaN(start) && !isNaN(end)) {
      const startDate = new Date(Date.UTC(start.getUTCFullYear() - 1, start.getUTCMonth(), start.getUTCDate()));
      const endDate = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));

      const startDateString = startDate.toISOString().substring(0, 10);
      const endDateString = endDate.toISOString().substring(0, 10);

      if (selectedSearchField === "orderID") {
        const orderIDQuery = parseInt(searchQuery, 10);
        GetOverviewOrders(1, startDateString, endDateString, selectedOrderType, orderIDQuery, "All", "");
      } else if (selectedSearchField === "clientFullName") {
        GetOverviewOrders(1, startDateString, endDateString, selectedOrderType, 0, "All", searchQuery);
      } else if (selectedSearchField === "type") {
        GetOverviewOrders(1, startDateString, endDateString, selectedOrderType, 0, searchQuery, "");
      } else if (selectedSearchField === "All") {
        GetOverviewOrders(1, startDateString, endDateString, selectedOrderType, 0, "All", "");
      }
    }
  };

  const handleOrderTypeChange = (e) => {
    const newOrderType = e.target.value;
    setSelectedOrderType(newOrderType);
  };

  const handleSearchFieldChange = (e) => {
    const value = e.target.value;
    if (value !== "") {
      setSelectedSearchField(value);

      setSearchQuery("");
    }
  };


  const handleSearchInputChange = (e) => {
    const value = e.target.value;

    if (selectedSearchField === "orderID") {
      if (/^\d*$/.test(value)) {
        setSearchQuery(value);
      }
    } else {
      setSearchQuery(value);
    }
  };

  const today = new Date();
  const dateOptions = {
    month: 'short',
  };
  const formattedDate = `Today, ${new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(today)}, ${today.getDate()} ${today.toLocaleDateString('en-US', dateOptions)}`;

  const options = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  // const handleDelete = (orderId) => {
  //   const payload = {
  //       orderId: orderId
  //   };
  //   dispatch(setActionType(ACTION_TYPES.DELETE_ORDER));
  //   dispatch(setActionPayload(payload));
  //   onOpenQrAfterGenerate(); 
  // };

  // const handleCancel = (orderId) => {
  //   const payload = {
  //     orderId: orderId
  // };
  // dispatch(setActionType(ACTION_TYPES.CANCEL_ORDER));
  // dispatch(setActionPayload(payload));
  // onOpenQrAfterGenerate(); 
  // }


  const handleOpenModal = (order) => {
    setSelectedOrder(order);
    dispatch(setShowOverviewDetialsPopup(true));
  };

  const handleOverviewClick = (label, subTitle) => {
    let status = '';
    let type = '';
    let startDate, endDate;

    if (label === 'New Order' && subTitle === 'Cash Out') {
      status = 'New';
      type = 'withdraw';
    } else if (label === 'Scheduled' && subTitle === 'Cash Out') {
      status = 'Scheduled';
      type = 'withdraw';
    } else if (label === 'New Order' && subTitle === 'Cash In') {
      status = 'New';
      type = 'pickup';
    } else if (label === 'Scheduled' && subTitle === 'Cash In') {
      status = 'Scheduled';
      type = 'pickup'; 
    } else if (label === 'Assigned Order' && subTitle === 'Assigned Order Gozilla') {
      status = 'Assigned';
      type = 'withdraw';
    } else if (label === 'Out For Pick-Up' && subTitle === 'Gozilla to Client') {
      status = 'Assigned';
      type = 'pickup';
    } else if (label === 'Out For Delivery' && subTitle === 'Cashroom to Client') {
      status = 'Cash Picked up';
      type = 'withdraw';
    } else if (label === 'Out For Delivery' && subTitle === 'Client to Cashroom') {
      status = 'Cash Picked up';
      type = 'pickup';
    } else if (label === 'Cancelled' && (subTitle === 'Cancelled WithDraw' || subTitle === 'Cancelled Pickup')) {
      status = 'Cancelled';
      type = subTitle.includes('WithDraw') ? 'withdraw' : 'pickup';
    } else if (label === 'Completed' && (subTitle === 'Completed WithDraw' || subTitle === 'Completed Pickup')) {
      status = 'Completed';
      type = subTitle.includes('WithDraw') ? 'withdraw' : 'pickup';
    }

    if (!startDate && !endDate) {
      const [start] = dateRange;
      endDate = new Date();
      startDate = new Date(Date.UTC(start.getUTCFullYear() - 1, start.getUTCMonth(), start.getUTCDate()));
    }

    const startDateString = startDate.toISOString().substring(0, 10);
    const endDateString = endDate.toISOString().substring(0, 10);

    GetOverviewOrders(1, startDateString, endDateString, status, 0, type, "")
      .then(() => {
        const tableSection = document.querySelector('.order-table');
        if (tableSection) {
          setTimeout(() => {
            tableSection.scrollIntoView({ behavior: 'smooth', block: 'end' });
          }, 200);
        }
      });
  };

  console.log("dashboardOrdersSummary", dashboardOrdersSummary);

  const columns = useMemo(() => [
    {
      Header: "Order ID",
      accessor: "orderID",
    },
    {
      Header: "User ID",
      accessor: "userId",
    },
    {
      Header: "",
      accessor: "details",
      Cell: ({ row }) => (
        <button className="showmore" onClick={() => setActiveRowIndex(row.index)}>
          <FontAwesomeIcon icon={faArrowDown} />
        </button>
      ),
    },
    {
      Header: "Type of Order",
      accessor: "type",
    },
    {
      Header: "Currency",
      accessor: "currency",
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ cell: { value, row } }) => {
        const currencySymbol = row.original.currency === "USD" ? `$ ${value}` : `${value} L.L`;
        return (
          <div style={{ fontFamily: "Poppins SemiBold" }}>
            {currencySymbol}
          </div>
        );
      }
    },
    {
      Header: "Date & Time Order Placed",
      accessor: "dateCreated",
      Cell: ({ cell: { value } }) => {
        return (
          <UtcToLocal
            utcTimestamp={value}
            options={options}
          />
        );
      }
    },
    {
      Header: "Date & Time Order Completed",
      accessor: "dateCompleted",
      Cell: ({ cell: { value, row } }) => {

        if (row.original.dateCompleted === null) {
          return null;
        } else {
          return (
            <div>
              <UtcToLocal
                utcTimestamp={value}
                options={options}
              />
            </div>
          );
        }
      }
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell: { value } }) => {
        if (["new", "new - scheduled", "out of delivery", "cancelled", "cancelled by client", "unknown", "order completed", "assigned - driver on its way to user", "assigned - driver on its way to portal", "cash picked up from cashroom - on its way to user", "cash picked up from user - on its way to portal", "cash picked up from user - on its way to cashroom"].includes(value?.toLowerCase())) {
          return <div className={"status " + value?.toUpperCase()}>{capitalizeFirstLetters(value)}</div>
        }
      }
    },
    {
      Header: "",
      accessor: "others",
      Cell: ({ row }) => {
        const status = row.original.status;

        // if (status === "Canceled" || status ===  "Cancelled By Client") {
        //   return (
        //     <button className="delete-btn" onClick={() => handleDelete(row.original.orderID)}>
        //       Delete
        //     </button>
        //   );
        // } else if  (status === "New") {
        //   return (
        //     <button className="cancel-btn" onClick={() => handleCancel(row.original.orderID)}>
        //       Cancel
        //     </button>
        //   )
        // } else if (status === "Out of delivery") {
        // return (
        //   <button className="details-btn" onClick={() => handleOpenModal(row.original)}>
        //     Details
        //   </button>
        // );
        // } else {
        //   return null; 
        // 
      }
    }
  ], []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data: overviewOrders || [] });

  const filteredRows = rows.filter((row) => {
    const orderStatus = row.original.status ? row.original.status.trim().toLowerCase() : "";

    const orderTypeMatch =
      selectedOrderType === "All Orders" ||
      (selectedOrderType === "Completed" && orderStatus === "order completed") ||
      (selectedOrderType === "On its way" && (orderStatus === "assigned - driver on its way to user" || orderStatus === "assigned - driver on its way to portal" || orderStatus === "cash picked up from cashroom - on its way to user")) ||
      (selectedOrderType === "Cash Picked up" && (orderStatus === "cash picked up from cashroom - on its way to user") || orderStatus === "cash picked up from user - on its way to cashroom")||
      orderStatus === selectedOrderType.toLowerCase();

    return orderTypeMatch;
  });
  


  return (
    <>
      <HeaderComponents title="Overview" />
      <div className="OverviewPage">
        <div className="col-lg-10 col-md-12 col-sm-12 overViewTopSection">
          <div className="MerchantName d-none d-md-block">
            {formattedDate}
          </div>
        </div>
        <>
          {loading ? (
            <div className="home-section">
              <div className="row gx-5">
                <OverviewAccountSkeleton />
                <OverviewAccountSkeleton />
              </div>
            </div>
          ) : (
            <>
              <div className="home-section">
                <div className='title'>CASH WITHDRAW</div>
                <div className="overview-cards">
                  <OverviewSection
                    label={"New Order"}
                    subTitle={"Cash Out"}
                    data={dashboardOrdersSummary?.overviewOrders?.newOrders?.withdraw?.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.newOrders?.withdraw?.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.newOrders?.withdraw?.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.newOrders?.withdraw?.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.newOrders?.withdraw?.currLBP}
                    image="/Images/NewOrdersOverview.svg"
                    onClick={() => handleOverviewClick("New Order", "Cash Out")}
                  />
                  {(role === "Arz" || role === "Support") && (
                  <OverviewSection
                    label={"Scheduled"}
                    subTitle={"Cash Out"}
                    data={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.withdraw?.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.withdraw?.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.withdraw?.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.withdraw?.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.withdraw?.currLBP}
                    image="/Images/NewOrdersOverview.svg"
                    onClick={() => handleOverviewClick("Scheduled", "Cash Out")}
                  />
                  )}
                  <OverviewSection
                    label={"Assigned Order"}
                    subTitle={"Assigned Order Gozilla"}
                    data={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.withdraw.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.withdraw.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.withdraw.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.withdraw.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.withdraw.currLBP}
                    image="/Images/AssignedOrders.svg"
                    onClick={() => handleOverviewClick("Assigned Order", "Assigned Order Gozilla")}

                  />
                    <OverviewSection
                    label={role === "Arz" ? "Out For Delivery" : "Completed"}
                    subTitle={role === "Arz" ? "Cashroom to Client" : ""}
                    data={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.withdraw.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.withdraw.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.withdraw.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.withdraw.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.withdraw.currLBP}
                    image={role === 'Arz' ? "/Images/OutOfDeliveryOrders.svg" : "/Images/CompletedOrders.svg"} 
                    onClick={() => handleOverviewClick("Out For Delivery", "Cashroom to Client")}
                  />
                  {(role === "Arz" || role === "Support") && (
                    <> 
                  <OverviewSection
                    label={"Cancelled"}
                    subTitle={"Cancelled WithDraw"}
                    data={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.withdraw.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.withdraw.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.withdraw.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.withdraw.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.withdraw.currLBP}
                    image="/Images/CancelledOrders.svg"
                    onClick={() => handleOverviewClick("Cancelled", "Cancelled WithDraw")}
                  />
                  <OverviewSection
                    label={"Completed"}
                    subTitle={"Completed WithDraw"}
                    data={dashboardOrdersSummary?.overviewOrders?.completedOrders?.withdraw.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.completedOrders?.withdraw.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.completedOrders?.withdraw.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.completedOrders?.withdraw.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.completedOrders?.withdraw.currLBP}
                    image="/Images/CompletedOrders.svg"
                    onClick={() => handleOverviewClick("Completed", "Completed WithDraw")}
                  />
                  </>
                  )}
                </div>
              </div>

              <div className="home-section">
                <div className='title'>CASH PICK UP</div>
                <div className="overview-cards">
                  {(role === "Arz" || role === "Support") && (
                  <>
                  <OverviewSection
                    label={"New Order"}
                    subTitle={"Cash In"}
                    data={dashboardOrdersSummary?.overviewOrders?.newOrders?.pickup?.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.newOrders?.pickup?.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.newOrders?.pickup?.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.newOrders?.pickup?.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.newOrders?.pickup?.currLBP}
                    image="/Images/NewOrdersOverview.svg"
                    onClick={() => handleOverviewClick("New Order", "Cash In")}
                  />
                  {(role === "Arz" || role === "Support") && (
                   <OverviewSection
                    label={"Scheduled"}
                    subTitle={"Cash In"}
                    data={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.pickup?.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.pickup?.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.pickup?.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.pickup?.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.scheduledOrders?.pickup?.currLBP}
                    image="/Images/NewOrdersOverview.svg"
                    onClick={() => handleOverviewClick("Scheduled", "Cash In")}
                  />
                  )}
                  <OverviewSection
                    label={"Out For Pick-Up"}
                    subTitle={"Gozilla to Client"}
                    data={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.pickup.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.pickup.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.pickup.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.pickup.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.awaitingOrders?.pickup.currLBP}
                    image="/Images/AssignedOrders.svg"
                    onClick={() => handleOverviewClick("Out For Pick-Up", "Gozilla to Client")}
                  />
                  </>
                  )}
                  <OverviewSection
                    label={"Out For Delivery"}
                    subTitle={"Client to Cashroom"}
                    data={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.pickup.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.pickup.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.pickup.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.pickup.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.outForDeliveryOrders?.pickup.currLBP}
                    image="/Images/OutOfDeliveryOrders.svg"
                    onClick={() => handleOverviewClick("Out For Delivery", "Client to Cashroom")}
                  />    
                  {(role === "Arz" || role === "Support") && (
                  <OverviewSection
                    label={"Cancelled"}
                    subTitle={"Cancelled Pickup"}
                    data={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.pickup.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.pickup.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.pickup.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.pickup.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.cancelledOrders?.pickup.currLBP}
                    image="/Images/CancelledOrders.svg"
                    onClick={() => handleOverviewClick("Cancelled", "Cancelled Pickup")}
                  />
                  )}
                  <OverviewSection
                    label={"Completed"}
                    subTitle={"Completed Pickup"}
                    data={dashboardOrdersSummary?.overviewOrders?.completedOrders?.pickup.count}
                    amountUSD={dashboardOrdersSummary?.overviewOrders?.completedOrders?.pickup.amountUSD}
                    currencyUSD={dashboardOrdersSummary?.overviewOrders?.completedOrders?.pickup.currUSD}
                    amountLBP={dashboardOrdersSummary?.overviewOrders?.completedOrders?.pickup.amountLBP}
                    currencyLBP={dashboardOrdersSummary?.overviewOrders?.completedOrders?.pickup.currLBP}
                    image="/Images/CompletedOrders.svg"
                    onClick={() => handleOverviewClick("Completed", "Completed Pickup")}
                  />
                </div>
              </div>
            </>
          )}
          {role === "Arz" && (
            <>
            {loading ? (
              <div className="home-section">
                <div className="row mb-4 p-3">
                  <OverviewAccountSkeleton />
                  <OverviewAccountSkeleton />
                </div>
              </div>
            ) : (
              <div className="home-section">
                <div className='title'>MONEY AVAILABLE AT CASHROOM</div>
                <div className="row gx-4 mt-4" style={{ marginBottom: "30px" }}>
                  <AccountsSection accountLoading={loading} currencyAccount="CURRENT USD ACCOUNT" balance={`$ ${formatUSD(dashboardOrdersSummary?.balances?.totalUSDAmount) || 0}`} />
                  <AccountsSection accountLoading={loading} currencyAccount="CURRENT LBP ACCOUNT" balance={`${formatLBP(dashboardOrdersSummary?.balances?.totalLBPAmount) || 0} L.L`} />
                </div>
              </div>
            )}
          </>
          )}
        </>
        {(role === "Arz" || role === "Support") && (
        <div className="col-lg-10">
          <div className='title'>ORDER OVERVIEW</div>
          <div className="filtering">
            <div className="filteringSearch">
              <input
                className="search"
                placeholder={`Search by ${selectedSearchField === 'clientFullName' ? 'Client Name'
                    : selectedSearchField === 'orderID' ? 'Order ID'
                      : selectedSearchField === 'type' ? 'Type'
                        : capitalizeFirstLetters(selectedSearchField)
                  }`}
                value={searchQuery}
                onChange={handleSearchInputChange}
                disabled={selectedSearchField === "All"}
              />
              <select
                className="ddselect"
                value={selectedSearchField}
                onChange={handleSearchFieldChange}
                style={{ width: "220px" }}
              >
                <option value="All">Search by All</option>
                <option value="orderID">Search by Order ID</option>
                <option value="clientFullName">Search by Client Name</option>
                <option value="type">Search by Type</option>
            </select>
              <button onClick={handleSearch} className="export" disabled={selectedSearchField !== "All" && searchQuery.trim() === ""}>Search</button>
            </div>
            <div className="select">
              <select
                className="ddselect"
                value={selectedOrderType}
                onChange={handleOrderTypeChange}
              >
                <option value="All Orders">All Orders</option>
                <option value="New">New</option>
                <option value="On its way">On it's way</option>
                <option value="Cash Picked up">Cash Picked up</option>
                <option value="Cancelled">Cancelled</option>
                <option value="Completed">Completed</option>
              </select>
            </div>
          </div>
          <div className="order-table">
            {overviewLoading ? (
              <TableSkeleton />
            ) : (
              <>
                <TableSelect
                  headerGroups={headerGroups}
                  page={filteredRows}
                  prepareRow={prepareRow}
                  getTableProps={getTableProps}
                  getTableBodyProps={getTableBodyProps}
                  activeRowIndex={activeRowIndex}
                  setActiveRowIndex={setActiveRowIndex}
                  handleOpenModal={handleOpenModal}
                  isOverview={true}
                />
                <PaginationOverview
                  totalNbOfPage={totalNbOfPage}
                  selectedPage={selectedPage}
                  setSelectedPage={setSelectedPage}
                  GetOverviewOrders={GetOverviewOrders}
                  dateFrom={lastRequest.dateFrom}
                  dateTo={lastRequest.dateTo}
                  status={lastRequest.status}
                  orderID={lastRequest.orderID}
                  type={lastRequest.type}
                  clientFullName={lastRequest.clientFullName}
                />
              </>
            )}
          </div>
        </div>
      )}
      </div>
      <BlurLoading />
      {showOverviewDetialsPopup &&
        <OverviewDetailsPopup order={selectedOrder} />
      }
    </>
  );
}

export default Overview;
